var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 741.08 397.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#534741;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    "data-name": "Layer 6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M175.19,238.51a26.59,26.59,0,0,0-2.19-16c-11.56-23.22-59.09-23.05-106.16.39S-9,284.14,2.55,307.36C9.82,322,31.31,327.31,58,323.45c-8.67,24.59-8.56,45.8,2.23,55.22,12,10.51,34.23,3.57,56.73-15.43,4.45,11.35,10.78,19,18.46,20.84,19.05,4.64,39.16-27.72,44.93-72.28,2.9-22.44,1.61-43.69-2.81-59.85A40.73,40.73,0,0,0,175.19,238.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M570.86,244.77a26.53,26.53,0,0,1,3.45-15.8c13.35-22.24,60.71-18.34,105.79,8.73s70.8,67,57.45,89.27c-8.39,14-30.23,17.62-56.49,11.68,6.71,25.2,4.93,46.33-6.57,54.87-12.83,9.54-34.41.87-55.34-19.83-5.33,11-12.24,18.06-20,19.32-19.34,3.13-36.85-30.71-39.1-75.58-1.14-22.6,1.82-43.69,7.5-59.45A40.74,40.74,0,0,1,570.86,244.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M288.94,173a26.58,26.58,0,0,0-1.15-16.13c-10-23.92-57.47-26.83-106-6.49s-79.66,56.21-69.63,80.13c6.31,15,27.41,21.77,54.25,19.65-10.25,24-11.51,45.15-1.36,55.25,11.34,11.27,33.93,5.78,57.62-11.72,3.7,11.61,9.52,19.62,17.07,22,18.7,5.86,40.87-25.12,49.52-69.21,4.35-22.21,4.44-43.5,1.07-59.91A40.52,40.52,0,0,0,288.94,173Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M567.12,194.52a19.75,19.75,0,0,0-10.18-6.33c-18.74-4.38-41.12,22.84-50,60.81s-.9,72.3,17.83,76.68c11.78,2.76,25-7,35.4-24,10,16.59,22.11,26.56,32.59,24.85,11.71-1.9,18.24-17.86,18-39.69,8.58,2.82,15.92,2.81,20.63-.69,11.66-8.68,2.69-35.48-20-59.85C600,214,587.21,204.68,575.89,199.56A30.1,30.1,0,0,0,567.12,194.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M345.56,107.67a26.63,26.63,0,0,0-13.9-8.26c-25.38-5.4-54.82,31.91-65.77,83.33s.75,97.5,26.12,102.9c15.95,3.39,33.51-10.09,47.07-33.36,13.86,22.1,30.53,35.21,44.61,32.63,15.73-2.89,24.11-24.58,23.24-54,11.64,3.58,21.55,3.36,27.8-1.49,15.48-12,2.67-47.9-28.62-80.14-15.75-16.24-33.19-28.46-48.6-35.05A40.26,40.26,0,0,0,345.56,107.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M535.31,144.57a26.5,26.5,0,0,0-5-15.36c-15.56-20.75-62.28-12-104.34,19.54s-63.55,73.94-48,94.69c9.79,13.05,31.88,14.43,57.4,5.83-4.09,25.75-.15,46.59,12.16,53.91,13.74,8.17,34.31-2.67,53-25.41,6.41,10.36,14,16.71,21.92,17.16,19.56,1.13,33.51-34.33,31.14-79.2-1.19-22.59-6.3-43.26-13.57-58.36A40.11,40.11,0,0,0,535.31,144.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106.81,208.41S178.68,83.1,351.54,82.31c174.56-.8,243.56,65.52,291.56,138.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M359.4,86.71S353.12-14.44,408.1,1.76,376,98.94,376,98.94Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset3);
export default __webpack_public_path__ + "static/media/Asset 3.78f304f6.svg";
export { ForwardRef as ReactComponent };